import script from "./autoLoginDemoEdgp.vue?vue&type=script&setup=true&lang=ts"
export * from "./autoLoginDemoEdgp.vue?vue&type=script&setup=true&lang=ts"

import "./autoLoginDemoEdgp.vue?vue&type=style&index=0&id=b18026cc&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18026cc"]])

export default __exports__